import { observer } from 'mobx-react';
import * as React from 'react';
import { Card, DateInput, IDateInputValue, NumberInput, TextInput, Grid, CurativeGradeInput } from 'ui-toolkit';
import { ISummaryData } from '../../../ui-toolkit/orders/interfaces/titleReport/ISummary';

interface IProps {
  data: ISummaryData;
  error?: any;
  title?: string;
  onFormChange: (dataPath: string, newData: any, error?: string | null | undefined) => void;
}

export const Summary = observer(
  class Summary extends React.Component<IProps, {}> {
    public static defaultProps: Partial<IProps> = {
      title: 'Summary',
    };

    public render() {
      const onCurativeGradChange = (value: { value: any | null | undefined } | null | undefined) =>
        this.props.onFormChange('summary.curativeGrade', value && value.value);
      const onEffectiveDateChange = (value: IDateInputValue) => {
        // TODO: preventing ui-toolkit/DateInput bug which triggers onFormChange
        // which then sets formDataChanged:true when it shouldn't
        if (value.value !== this.props.data.effectiveDate) {
          this.props.onFormChange('summary.effectiveDate', value.value);
        }
      };
      const onApnChange = (value: string | null | undefined, error: string | null | undefined) =>
        this.props.onFormChange('summary.apn', value, error);
      const generateNumberChangeHandler =
        (fieldPath: string) => (value: number | null | undefined, error: string | null | undefined) =>
          this.props.onFormChange(fieldPath, value, error);
      const onMortgageChange = generateNumberChangeHandler('summary.openMortgages');
      const onBankruptciesChange = generateNumberChangeHandler('summary.bankruptcies');
      const onJudgementsChange = generateNumberChangeHandler('summary.judgements');
      const onOtherLiensChange = generateNumberChangeHandler('summary.otherLiens');
      return (
        <Card title={this.props.title}>
          <Grid>
            <Grid columnCount={3}>
              <CurativeGradeInput
                value={this.props.data.curativeGrade}
                label="Curative grade"
                isClearable
                placeholder="Select"
                onChange={onCurativeGradChange}
              />
              <DateInput
                value={this.props.data.effectiveDate || null}
                errorText={this.props.error?.['summary.effectiveDate']}
                label="Effective date"
                onChange={onEffectiveDateChange}
              />
              <TextInput
                value={this.props.data.apn}
                label="Assessor's parcel number/tax id"
                placeholder="XXXXXXXXXX"
                onChange={onApnChange}
              />
            </Grid>

            <Grid columnCount={4}>
              <NumberInput
                value={this.props.data.openMortgages}
                label="Open mortgages"
                placeholder="XX"
                onChange={onMortgageChange}
              />
              <NumberInput
                value={this.props.data.bankruptcies}
                label="Bankruptcies"
                placeholder="XX"
                onChange={onBankruptciesChange}
              />
              <NumberInput
                value={this.props.data.judgements}
                label="Judgements"
                placeholder="XX"
                onChange={onJudgementsChange}
              />
              <NumberInput
                value={this.props.data.otherLiens}
                label="Other liens"
                placeholder="XX"
                onChange={onOtherLiensChange}
              />
            </Grid>
          </Grid>
        </Card>
      );
    }
  }
);
